<template>
    <div class="modal fade" id="teammemmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add Team Members</h5>
                </div>
                <div class="modal-body">
                    <div class="row form invite-email-blk">
                        <div class="col-md-5">
                            <input type="text" v-model="inviteEmail" placeholder="Enter Email" />
                        </div>
                        <div class="col-md-5">
                            <div class="input-select-field form-input">
                                <select v-model="inviteRole">
                                    <option v-for="list1 in roleList" :value="list1._id">{{list1.role}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2 input-submit">
                            <a href="javascript:void(0)" class="invite-btn" v-on:click="inviteMember">{{inviteText}}</a>
                        </div>
                    </div>
                    <div class="row" v-for="(list) in newArtists" v-if="newArtists && list.profiles[0].profession" v-bind:key="list._id">
                        <div class="col-md-5 r-p">
                            <div class="p-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }"></div>
                            <h3>{{list.name}}</h3>
                        </div>
                        <div class="col-md-5">
                            <div class="input-select-field form-input">
                                <select>
                                    <option v-for="list1 in roleList" :value="list1._id">{{list1.role}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2 se-c text-right">
                            <label :for="`remote_checkbox_`+list._id" :data-artistId="list._id" :data-stageId="stageId" v-on:click="chooseMember">
                                <img src="@/assets/img/check_mark.png" width="45" />
                            </label>
                            <input class="checkbox-remote" type="checkbox" :id="`remote_checkbox_`+list._id"  />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" v-on:click="saveMemebers">Save changes</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import emailImage from '@/assets/img/email/img1.png'
    import router from '../../router'
    import $ from "jquery"
    import axios from 'axios'
    export default {
        name: 'inviteMembers',
        props: ['stageId'],
        data () {
            let userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                value: 1,
                progressFlag: false,
                roleCount: 1,
                choosedMemberList: '',
                inviteText: 'Invite',
                inviteEmail: '',
                emailImage: emailImage,
                deleteRecord: '',
                model: 'Temp',
                inviteRole: '',
                tempMembers: '',
                roleList: '',
                userData: userdata,
                memebrs: '',
                memebrsId: '',
                newArtists: '',
                artists: '',
                imageUrl: process.env.imageUrl,
                userId: userdata.user.id,
                userName: userdata.user.name
            }
        },
        mounted () {
            axios
                .get('/artists', {})
                .then(response => {
                    let $this = this
                    let newArtist = []
                    this.artists = response.data
                    this.artists.map(function (value, key) {
                        if(!$this.memebrsId.includes(value._id)){
                            newArtist.push(value)
                        }
                    })
                    this.newArtists = newArtist
                })
                .catch(error => console.log(error))

            axios
                .get('/getTempMembersByStageId', {
                    params: {
                        stageId: this.stageId
                    },
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                })
                .then(response => {
                    this.tempMembers = response.data
                })
                .catch(error => console.log(error))
            axios
                .get('/getMembers', {
                    params: {
                        stageId: this.stageId
                    }
                })
                .then(response => {
                    this.roleList = response.data
                    this.roleCount = 0
                    console.log(this.roleCount)
                    let memebrs = []
                    let memebrsId = []
                    $.each(response.data, function(key, value) {
                        if(value.appliedArtist.length){
                            $.each(value.appliedArtist, function(key1, value1) {
                                value1.role = value.role
                                value1.roleId = value._id
                                memebrs.push(value1)
                                memebrsId.push(value1._id)
                            })
                        }
                    })
                    this.memebrs = memebrs
                    this.memebrsId = memebrsId
                    console.log('members', memebrs)
                    // console.log(response.data)

                })
                .catch(error => console.log(error))
        },
        methods: {
            inviteMember: function(event){
                this.inviteText = 'Inviting...'
                axios.post('/addMemeberInTemp', {
                    email: this.inviteEmail,
                    roleId: this.inviteRole,
                    userId: this.userId,
                    userName: this.userName,
                    emailImage: this.emailImage,
                    stageId: this.stageId
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(res => {
                    this.inviteText = 'Invite'
                    if(res.data == 'exist'){
                        Vue.$toast.open(
                            {
                                message: 'User Exists!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    } else {
                        location.reload()
                    }
                }).catch(err => {
                    this.inviteText = 'Invite'
                    Vue.$toast.open(
                        {
                            message: 'Something goes wrong!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    console.log(err)
                })
            },
            chooseMember: function(event){
                $(event.target).toggleClass('active-checkbox')
                var mBlock = []
                var mObject = {}
                $('#teammemmodal .active-checkbox').each(function () {
                    mObject = {
                        artistId: $(this).closest('label').attr('data-artistId'),
                        stageId: $(this).closest('label').attr('data-stageId'),
                        roleId: $(this).closest('.row').find('select').val()
                    }
                    mBlock.push(mObject)
                })
                this.choosedMemberList = mBlock
            },
            saveMemebers: function(){
                if(this.choosedMemberList){
                    $(event.target).text('Saving...')
                    axios.post('/addMemeberFromStage', {
                        choosedMemberList: this.choosedMemberList
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        location.reload()
                        $(event.target).text('Save Change')
                        Vue.$toast.open(
                            {
                                message: 'Member added successfully',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    }).catch(err => {
                        $(event.target).text('Save Change')
                        Vue.$toast.open(
                            {
                                message: 'Something goes wrong!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        console.log(err)
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/include/inviteMembers.vue